// Global hardening: avoid runtime crashes when code calls `response.json()` but the server
// returns an empty body or an HTML error page (common for 404/502/proxy issues).
//
// IMPORTANT: This file must be imported BEFORE other app modules that might call fetch().
// Put `import './responseJsonPatch';` at the top of `src/index.js`.
if (typeof Response !== 'undefined' && Response.prototype && typeof Response.prototype.json === 'function') {
  const originalJson = Response.prototype.json;
  Response.prototype.json = async function patchedJson() {
    const cloned = typeof this.clone === 'function' ? this.clone() : null;
    try {
      return await originalJson.call(this);
    } catch (_) {
      try {
        const text = cloned ? await cloned.text() : '';
        if (!text) return {};
        try {
          return JSON.parse(text);
        } catch (_) {
          return { __nonJson: true, __rawTextPreview: String(text).slice(0, 500) };
        }
      } catch (_) {
        return {};
      }
    }
  };
}

